import { useState } from 'react';
import { useMe } from '../auth/useMe';
import { SystemField } from '../events/EventFields';
import { canManageSettings } from './access';
import { SettingsDialog } from './SettingsDialog';
import { SystemsSettings } from './SystemsSettings';
import { useSystems } from './systems';

/** The "System" field with its list loaded and, for whoever may change the list, the gear opening it in a dialog. */
export function SystemChoice({ value, onChange, error }: { value: string; onChange: (id: string) => void; error?: string | undefined }) {
  const { me } = useMe();
  const list = useSystems();
  const [open, setOpen] = useState(false);
  const canManage = !!me && canManageSettings(me).systems;
  return (
    <>
      <SystemField value={value} onChange={onChange} systems={list.data?.systems ?? []} onManage={canManage ? () => setOpen(true) : undefined} error={error} />
      {open && me && (
        <SettingsDialog title="Systemy" onClose={() => setOpen(false)}>
          <SystemsSettings me={me} heading={false} />
        </SettingsDialog>
      )}
    </>
  );
}
